export const ENDPOINTS = {
  LOGIN: '/api/login',
  COMPETITIONS: '/competitions/',
  TEAM_MEMBER_OPTIONS: '/reps',
  COMPETITION_TEAMS: '/competition_teams',
  COMPETITION_EVENTS: '/competition_events',
  CREATE_TEAM: '/api/team_members',
  COMPETITION_TEAM_MEMBERS: '/competition_team_members',
  ADMIN_COMPETITIONS: '/admin/competitions'
};